/** @file A vector multiplied by a scalar. */
import type { Vec3 } from './vec3';

/** `v * s`. */
export function vec3Scale(v: Vec3, s: number): Vec3 {
  return [v[0] * s, v[1] * s, v[2] * s];
}
